// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachWeekendOfYear as fn } from "../eachWeekendOfYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachWeekendOfYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default eachWeekendOfYear;
